<!-- Sidebar Wrapper -->
<button class="btn border-0 toggler-icon" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileSidebar"
    aria-label="Open menu">
    <i class="fa-solid fa-bars menu-icon ms-0 d-none d-md-block" [ngClass]="themeClass('sidebar-menu-section1')">
    </i>
</button>
<div class="sidebar-menu-toggler">
    <div class="offcanvas offcanvas-start" tabindex="-1" id="mobileSidebar">
        <div class="offcanvas-header d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <div class="mobile-menu-icon me-3">
                    <button class="btn border-0" type="button" data-bs-dismiss="offcanvas" aria-label="Close">
                        <i class="fa-solid fa-bars"> </i>
                    </button>
                </div>
                <app-shop-by-vehicle data-bs-dismiss="offcanvas" aria-label="Close"
                    *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
            </div>
            <button type="button" class="btn border-0 p-0" data-bs-dismiss="offcanvas" aria-label="Close">
                <img [src]="commonImagePath +closeIcon" alt="Close" />
            </button>
        </div>
        <div class="offcanvas-body shop-cat" id="myOffcanvasBody" [ngClass]="themeClass('sidebar-menu-section2')">
            <!-- MAIN MENU -->
            <div [ngClass]="{ 'd-none': isSubMenuOpen }" id="mainMenu">
                <h6 class="shop-cat-titile mb-1">Shop By Category</h6>
                <ul class="list-unstyled mb-4 category-list">
                    <li *ngFor="let cat of categoryData"
                        class="d-flex justify-content-between align-items-center side-line">
                        <a class="cursor-pointer" (click)="openSubCategoryData(cat)">
                            {{ cat.name | removeBackslash }}
                        </a>
                        <button class="btn border-0 p-0 btn-prev cursor-pointer" (click)="openSubCategoryData(cat)">
                            <img [src]="commonImagePath+'next_img.webp'" alt="Next" />
                        </button>
                    </li>
                </ul>
            </div>
            <!-- SUBCATEGORY MENU -->
            <div [ngClass]="{ 'd-none': !isSubMenuOpen }" id="subCategoryMenu">
                <button class="btn ps-0 fw-bold" (click)="closeSubCategory()">
                    <img [src]="commonImagePath+'previous-img.webp'" alt="Back" />
                    {{ selectedCategoryTitle }}
                </button>
                <ul class="list-unstyled mb-4 category-list" *ngIf="!!subCategoryList && !showCategoryDetails">
                    <li *ngFor="let cat of subCategoryList"
                        class="d-flex justify-content-between align-items-center side-line">
                        <a class="cursor-pointer" (click)="openSubCategory(cat)">
                            {{ cat.name | removeBackslash}}
                        </a>
                        <button class="btn border-0 p-0 btn-prev cursor-pointer" (click)="openSubCategory(cat)">
                            <img [src]="commonImagePath+'next_img.webp'" alt="Next" />
                        </button>
                    </li>
                </ul>
            </div>
            <ng-container *ngIf="showTopSellerCat && topSellersData?.length > 0">
                <h6 class="shop-cat-titile mb-1">Top Sellers</h6>
                <ul class="list-unstyled mb-4 category-list">
                    <li *ngFor="let data of topSellersData" class="side-line" (click)="categoriesRedirection(data)">
                        <a class="cursor-pointer">{{data?.name || ''}}</a>
                    </li>
                </ul>
            </ng-container>
            <div class="mb-4 btn-shoppromos" *ngIf="showBrandBtn || showPromoBtn">
                <button *ngIf="showBrandBtn" class="btn shop-btn w-75 mb-2" data-bs-dismiss="offcanvas"
                    [routerLink]="'/brands'">Shop By
                    Brand</button>
                <button *ngIf="showPromoBtn" class="btn promos-btn w-75" data-bs-dismiss="offcanvas"
                    [routerLink]="'/promos'">Promos
                    &
                    Rebates</button>
            </div>
            <div class="account-section">
                <ng-container *ngFor="let menu of leftMenu">
                    <a class="account-link cart-link" *ngIf="menu.menu_name === 'My Cart'" [routerLink]="menu.menu_link"
                        data-bs-dismiss="offcanvas" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" loading="lazy" /> {{
                        menu.menu_name }}
                        <span class="cart-badge">{{ cartItems || 0 }}</span>
                    </a>
                    <a class="account-link" *ngIf="menu.menu_name === 'My Account'" (click)="onAccountButton()"
                        data-bs-dismiss="offcanvas" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" loading="lazy" /> {{
                        menu.menu_name }}
                    </a>
                    <a class="account-link" *ngIf="menu.menu_name === 'Order Status'" (click)="onOrderStatus()"
                        data-bs-dismiss="offcanvas" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" loading="lazy" /> {{
                        menu.menu_name }}
                    </a>
                    <a class="account-link" *ngIf="menu.menu_name === 'Wish List'" [routerLink]="['/my-wishlist']"
                        data-bs-dismiss="offcanvas" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" loading="lazy" /> {{
                        menu.menu_name }}
                        <span class="cart-badge">{{wishItems}}</span>
                    </a>
                    <a class="account-link"
                        *ngIf="menu.menu_name !== 'My Cart' && menu.menu_name !== 'My Account' && menu.menu_name !== 'Order Status' && menu.menu_name !== 'Wish List' && menu.menu_name !== 'Services' && menu.menu_name !== 'Reprogramming Services' && menu.menu_name !== 'The Engine Room Blog' "
                        [routerLink]="menu.menu_link " data-bs-dismiss="offcanvas" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" loading="lazy" /> {{
                        menu.menu_name }}
                    </a>
                    <a class="account-link" *ngIf=" menu.load_child_menus?.length > 0 "
                        (click)="showServiceSubDropdown()" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" loading="lazy" /> {{
                        menu.menu_name }}
                    </a>
                    <ng-container class="drop-navmenu"
                        *ngIf="showServiceSubDropdownFlag && menu.load_child_menus?.length > 0 ">
                        <ul class="drop-menu  text-start ps-0 position-relative">
                            <li *ngFor="let child of menu.load_child_menus"
                                class="d-flex justify-content-between align-items-center side-line"><a
                                    data-bs-dismiss="offcanvas" [routerLink]="child.menu_link" aria-label="Close"
                                    (click)="onClick(child?.menu_link,child?.menu_name)">{{child.menu_name}}</a></li>
                        </ul>
                    </ng-container>
                </ng-container>
            </div>
            <!-- Phone Number -->
            <div class="d-flex justify-content-between account-section ">
                <div class="mt-3 contact-num">
                    <a href="tel:{{contact}}" class="d-block account-link border-0">
                        <img [src]="commonImagePath+'phone_sidebar_img.png'">{{formatted_contact}}</a>
                </div>
                <!-- Logo -->
                <div class="mt-3 text-center">
                    <img [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.website_side_menu_logo"
                        alt="Logo" class="img-fluid" loading="lazy" />
                </div>
            </div>
        </div>
    </div>
</div>
<!-- My Account Offcanvas -->
<ng-container>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="myAccountOffcanvas" aria-labelledby="myAccountOffcanvasLabel"
        data-bs-scroll="false" data-bs-backdrop="true">
        <div class="offcanvas-body  position-relative ">
            <div class="row header-top">
                <div class="text-start fw-bold top-name col-8">Welcome {{userName}}</div>
                <div class="d-flex justify-content-end mycart">
                    <div class="col-4 col-md-3">
                        <a class="account-link cart-link" [routerLink]="['/cart']" data-bs-dismiss="offcanvas"
                            aria-label="Close">
                            <img [src]="getMenuImage('My Cart')" alt="My Cart" class="pe-3" />
                            <span class="cart-name">Cart</span>
                            <span class="myacc-cart-badge">{{ cartItems || 0 }}</span>
                        </a>
                    </div>
                </div>
                <button type="button" class="btn-close position-absolute end-0 top-0 m-2 col-1 pt-3" aria-label="Close"
                    data-bs-dismiss="offcanvas">
                </button>
            </div>
            <div class="account-section">
                <ng-container *ngFor="let menu of rightMenu">
                    <a class="account-link" *ngIf="menu.menu_name !== 'Wish List' " [routerLink]="menu.menu_link"
                        data-bs-dismiss="offcanvas" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" /> {{ menu.menu_name }}
                    </a>
                    <a class="account-link" *ngIf="menu.menu_name === 'Wish List'" [routerLink]="['/my-wishlist']"
                        data-bs-dismiss="offcanvas" aria-label="Close">
                        <img [src]="getMenuImage(menu.menu_name)" alt="{{ menu.menu_name }}" /> {{ menu.menu_name }}
                        <span class="cart-badge">{{wishItems}}</span>
                    </a>
                </ng-container>
            </div>
            <div class=" d-flex text-start mt-3 ps-0 fw-bold">
                <span>Not {{userName}}?</span>
                <a class="sign-out ps-3" data-bs-dismiss="offcanvas" (click)="onLogout()">
                    Sign Out
                </a>
            </div>
            <!-- Phone Number -->
            <div class="d-flex justify-content-between account-section ">
                <div class="mt-2 contact-num">
                    <a href="tel:{{contact}}" class="d-block account-link border-0">
                        <img [src]="commonImagePath+'phone_sidebar_img.png'">{{formatted_contact}}</a>
                </div>
                <!-- Logo -->
                <div class="mt-2 text-center">
                    <img [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.website_side_menu_logo"
                        alt="Logo" class="img-fluid " loading="lazy">
                </div>
            </div>
        </div>
    </div>
</ng-container>